import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import { listenForHistoryChange } from 'redux-location-state';
import createAppStore from './store';
import history from './history';
import settings from './conf';

import Sidebar from './components/Sidebar';
import Loading from './components/Loading';
import SettingsControl from './components/SettingsControl'
import LanguageControl from './components/LanguageControl'
import Shortcuts from './components/Shortcuts'
import SearchWaypoint from './components/SearchWaypoint'
import SplashScreenManager from './components/SplashScreenManager'
import ErrorManager from './components/ErrorManager'
import SettingsManager from './components/SettingsManager'
import ViewportManager from './components/ViewportManager'
import ScrollManager from './components/ScrollManager'
import MessagesManager from './components/MessagesManager'
import SettingsContext from './components/SettingsContext'

const renderApp = (App, slices, settings, location) => {

  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c

▓█████▄ ▓█████  ██▒   █▓ ███▄ ▄███▓ ▒█████  ▓█████▄ ▓█████ 
▒██▀ ██▌▓█   ▀ ▓██░   █▒▓██▒▀█▀ ██▒▒██▒  ██▒▒██▀ ██▌▓█   ▀ 
░██   █▌▒███    ▓██  █▒░▓██    ▓██░▒██░  ██▒░██   █▌▒███   
░▓█▄   ▌▒▓█  ▄   ▒██ █░░▒██    ▒██ ▒██   ██░░▓█▄   ▌▒▓█  ▄ 
░▒████▓ ░▒████▒   ▒▀█░  ▒██▒   ░██▒░ ████▓▒░░▒████▓ ░▒████▒
 ▒▒▓  ▒ ░░ ▒░ ░   ░ ▐░  ░ ▒░   ░  ░░ ▒░▒░▒░  ▒▒▓  ▒ ░░ ▒░ ░
 ░ ▒  ▒  ░ ░  ░   ░ ░░  ░  ░      ░  ░ ▒ ▒░  ░ ▒  ▒  ░ ░  ░
 ░ ░  ░    ░        ░░  ░      ░   ░ ░ ░ ▒   ░ ░  ░    ░   
   ░       ░  ░      ░         ░       ░ ░     ░       ░  ░
 ░                  ░                        ░             

`, "color: red;")
  }

  const reducers = {}

  for (const slice of slices){
    reducers[slice.name] = slice.reducer
  }

  const store = createAppStore(reducers, history, location);
  listenForHistoryChange(store, history);

  const root = (
    <SettingsContext.Provider value={settings}>
      
      <Provider {...{store}}>
        <SplashScreenManager/>
        <ErrorManager>
          <SettingsManager/>
          <ViewportManager/>
          <Router {...{history: history}} >
            <MessagesManager/>
            <ScrollManager/>
            <App/>
          </Router>
          <Sidebar name="search" position="right">
            <SearchWaypoint/>
          </Sidebar>
          <Sidebar name="menu" position="right">
            <LanguageControl/> 
            <SettingsControl/> 
            <Shortcuts/>
            <div className="sidebar-version">
              { settings.VERSION }
            </div>
          </Sidebar>
        </ErrorManager>
      </Provider>
    </SettingsContext.Provider>
  );

  const container = document.getElementById('container');
  ReactDOM.render(root, container);

  if (module.hot) {
    module.hot.accept()
  }
}

export default renderApp
